export default function ({ authentication }) {
  async function updateChameleonProperties() {
    const { getSession } = await authentication.loadAuth0()

    const { user, organization, profile } = await getSession()

    chmln.identify(user.id, {
      email: user.email,
      created: user.createdAt,
      name: user.name,
      role: profile.name,
      logins: user.email,
      lang: navigator.language || undefined,
      company: {
        uid: organization.id,
        created: organization.createdAt,
        name: organization.name,
        plan: organization.zenviaPlan,
      },
      product: user.system,
    })
  }

  return {
    updateChameleonProperties,
  }
}
